import { useMediaQuery, useTheme } from '@material-ui/core';

export const useIsSmallScreen = () => {
  const theme = useTheme();
  const isSmallPortrait = useMediaQuery(
    `${theme.breakpoints.down('xs')} and (orientation: portrait)`
  );
  const isSmallLandscape = useMediaQuery(
    `${theme.breakpoints.down('sm')} and (orientation: landscape)`
  );

  return isSmallPortrait || isSmallLandscape;
};
